import { useMemo } from 'react';
import { useComputedColorScheme, useMantineTheme } from '@mantine/core';
import { MRT_Row } from 'mantine-react-table';
import { Claim } from 'interfaces';
import { CLAIM_TARIFF_STATUS } from '@billing/validation/tariff';
import { claimHasTariffStatus } from 'utils/claimStatusUtils';

interface UseInvalidRowHighlightingProps {
  invalidData: string[]; // Array of IDs for rows with invalid data
}

const useInvalidRowHighlighting = ({
  invalidData,
}: UseInvalidRowHighlightingProps) => {
  const theme = useMantineTheme();
  const computedColorScheme = useComputedColorScheme('dark');
  // Memoize the row props function to optimize performance
  const mantineTableBodyRowProps = useMemo(
    () =>
      ({ row }: { row: MRT_Row<Claim> }) => {
        const isRowInvalid = invalidData?.includes(row.original.id);
        const resubmittedRow =
          row?.original?.submissions?.length >= 1 &&
          claimHasTariffStatus(row.original, CLAIM_TARIFF_STATUS.READY);
        return {
          'data-testid': isRowInvalid
            ? 'invalid-row'
            : resubmittedRow
            ? 'resubmitted-row'
            : undefined,
          style: {},
        };
      },
    [invalidData, theme, computedColorScheme]
  );

  return { mantineTableBodyRowProps };
};

export default useInvalidRowHighlighting;
